import { render, staticRenderFns } from "./groupTable.vue?vue&type=template&id=00fda966"
import script from "./groupTable.vue?vue&type=script&lang=js"
export * from "./groupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports